import { styled } from '@linaria/react';
import { colors, layout, space } from '../../theme/tokens';

export const TopBar = styled.div<{ $borderless?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${space[3]} ${space[5]};
  border-bottom: ${({ $borderless }) => ($borderless ? 'none' : `1px solid ${colors.borderGrey}`)};
  background: ${colors.white};
  position: sticky;
  top: 0;
  z-index: 50;
  min-height: 56px;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[3]} ${space[7]};
  }
`;
